/**
 * Enum listant les conditions de workflow.
 * @remarks : voué à disparaitre
 */
export enum ElementVisibilityTypes {
    ActivationEvent = 1,
    CompleteEvent = 2,
    OtherEvent = 3,
}
